import { Box } from "@mui/material";
import React from "react";
import { formatCurrency } from "../../utils/currency";

function PaymentInfoItemCard({ item }) {
  return (
    <Box>
      <Box className="settle-item-wrap border">
        <Box className="f-14 settle-item-name">
          {item?.variant_name || "item"}
        </Box>
        <Box className="settle-item-qty">
          <Box>{item?.quantity}x</Box>
          <Box>{formatCurrency(item?.current_price?.final_price)}</Box>
        </Box>
      </Box>
    </Box>
  );
}

export default PaymentInfoItemCard;
